export const NFTCONTRACT = "0x55A770E205E750A4252413C59aFA4acEE8e8FAFE";
export const STAKINGCONTRACT = "0x4de58F450641BD32Ef95d63f45bA7d467e13A100";
export const polygonscanapi = "https://api.polygonscan.com/";
export const moralisapi = "https://deep-index.moralis.io/api/v2/";
export const nftpng = "https://ipfs.io/ipfs/bafybeicpeygslgr42ix37wwaq5dfjqysun6623tfa3v5hxvtt4ap5rqq3q/";